import config from '@framework/config';
import EVERCALL_URL from '@evercall/url/urlConstants';
import condorUrl from '@/condor/infrastructure/condorUrl';
import drsUrl from '@drs/url';
import usersUrl from '@users/url';
/*
Yep, I know :(
But please look on this funny cat while trying to work with this.
         /\_/\
    ____/ o o \
  /~____  =ø= /
 (______)__m_m)
 */

/*
* Dynamic logout targets mapping. ORDER MATTERS!!!
* */
const logoutTargets: Array<{
  pattern: RegExp,
  getTarget: (isAutoLogout: boolean) => string,
}> = [
  { // Condor
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.condorDomain }.*\/.*`),
    getTarget: () => usersUrl.getLoginUrl(condorUrl.getPropagateUrl()),
  },
  {
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.usersDomain }.*\/profile.*`),
    getTarget: () => usersUrl.getLoginUrl(),
  },
  { // Manager viewer
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.dealroadshowDomain }.*\/manager\/.*`),
    getTarget: () => usersUrl.getLoginUrl(drsUrl.getPropagateUrl()),
  },
  { // Retail roadshow
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.dealroadshowDomain }.*\/(viewer\/|e\/).*\/retail`),
    getTarget: () => `${ config.protocol }//${ config.dealroadshowDomain }/retail`,
  },
  { // Cross deal analytics
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/analytics.*`),
    getTarget: () => usersUrl.getLoginUrl(),
  },
  { // Cross deal analytics
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/accounts.*`),
    getTarget: () => usersUrl.getLoginUrl(),
  },
  { // Roadshow
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/roadshow.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl(drsUrl.getPropagateUrl());
      }

      return `${ config.protocol }//${ config.dealroadshowDomain }/`;
    },
  },
  { // Investor viewer
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.dealroadshowDomain }.*\/(viewer\/|e\/).*`),
    getTarget: () => `${ config.protocol }//${ config.dealroadshowDomain }/`,
  },
  { // DealVDR
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/dealvdr.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.dealvdrDomain }`;
    },
  },
  { // LoanSend
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/loansend.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.loansendDomain }`;
    },
  },
  { // 17g5
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/17g5.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.seventeeng5Domain }/`;
    },
  },
  { // Investorset
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/investorset.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.investorsetDomain }/`;
    },
  },
  { // Verisend
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/verisend.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.verisendDomain }/`;
    },
  },
  { // Researchroom
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/researchroom.*`),
    getTarget: (isAutoLogout) => {
      if (isAutoLogout) {
        return usersUrl.getLoginUrl();
      }

      return `${ config.protocol }//${ config.researchroomDomain }/`;
    },
  },
  { // Deal Manager Portal
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.managerDomain }.*\/.*`),
    getTarget: () => usersUrl.getLoginUrl(),
  },
  { // Evercall Chat
    // eslint-disable-next-line no-useless-escape
    pattern: new RegExp(`(http.{0,1}:\/\/){0,1}${ config.evercallDomain }\..*\/.*`),
    getTarget: () => `${ config.protocol }//${ config.evercallDomain }${ EVERCALL_URL.DASHBOARD }`,
  },
];

export default logoutTargets;
